import React from 'react';

const expertAdviceBlock = (
  <p>Have more questions about what to write on your wedding website? Head on over to <a href="/expert-advice/how-to-write-your-wedding-website" target="_blank">this article</a> for expert advice.</p>
);

const EditPagesTipsContent = {
  'HOME': {
    'title': 'Story Ideas For Your Website',
    'dek':
      <>
        <p>Couples often welcome guests to their website with special stories about their relationship. It’s a great way to showcase your personalities and get everyone excited for the big day. Not sure what to write? Here are some suggestions.</p>
        <p><strong>Your “How We Met” Story:</strong><br/>Write a short and sweet summary of how you two met and began your relationship.</p>
        <p><strong>Your Proposal Story:</strong><br/>Tell guests how the proposal unfolded (and include photos if you have ‘em, too!).</p>
        <p><strong>Your Relationship Timeline:</strong><br/>Take guests through all the major milestones of your relationship.</p>
        { expertAdviceBlock }
      </>,
  },
  'EVENT': {
    'title': 'What To Include On Your Schedule Page',
    'dek':
      <>
        <p>Make sure guests know what to expect throughout the wedding weekend with a detailed schedule of events. Couples typically include the following info for each event on their website:</p>
        <ul>
          <li>Event name</li>
          <li>Event location</li>
          <li>Event date</li>
          <li>Start and end times</li>
          <li>Attire suggestions</li>
          <li>Personalized note for guests</li>
        </ul>
        { expertAdviceBlock }
      </>,
  },
  'TRAVEL': {
    'title': 'What To Include On Your Travel Page',
    'dek':
      <>
        <p>Help guests figure out how to get around, and where to stay, throughout the wedding weekend. Here’s a breakdown of all the important travel and lodging info guests might need.</p>
        <p><strong>Places to Stay:</strong><br/>Recommend a few hotels or Airbnb rentals near the wedding venue for out-of-town guests.</p>
        <p><strong>Hotel Blocks:</strong><br/>If you decide to provide accommodations for guests, include all the details they need to book, like reserve-by dates, discount codes, and more.</p>
        <p><strong>Flight Info:</strong><br/>What’s the most convenient airport for guests to fly into? Are there any flight options you recommend? List them on this page.</p>
        <p><strong>Train Info:</strong><br/>If guests have the option to travel by train, add train times, directions, and other details here.</p>
        <p><strong>Transportation:</strong><br/>Tell guests about any local shuttles, buses, or rental car companies. If you secure discounts for guests, share those codes on this page, too.</p>
        <p><strong>Parking:</strong><br/>Consider guests arriving by car. Where can they park? How far is parking to the venue? Will there be valets or attendants?</p>
        { expertAdviceBlock }
      </>,
  },
  'WEDDING_PARTY': {
    'title': '4 Ideas For Wedding Party Bios',
    'dek':
      <>
        <p>Guests love reading about the special people (or pets!) who play an important role in your ceremony. Wondering how to break the ice? Here are four ideas to help you get started.</p>
        <ol>
          <li>
            <p><strong>Show your appreciation.</strong></p>
            <p>Honor each person in your wedding party with a few thoughtful sentences about what they mean to you. Or keep it short and sweet, whatever feels most natural to you two.</p>
          </li>
          <li>
            <p><strong>Take a trip down memory lane.</strong></p>
            <p>Tell guests how you met each member of your wedding party and how long you’ve known them. Include a few favorite memories, funny anecdotes, and more.</p>
          </li>
          <li>
            <p><strong>Have fun with it.</strong></p>
            <p>Introduce each person with a playful title, like “Professional Napper” or “Dad Joke Connoisseur.” You can also list fun facts or personality traits you love about them.</p>
          </li>
          <li>
            <p><strong>Ask your wedding party to take over.</strong></p>
            <p>Consider asking everyone to write their own bios, and give them free rein to let their personalities shine on this page.</p>
          </li>
        </ol>
        { expertAdviceBlock }
      </>,
  },
  'PHOTO': {
    'title': 'Types Of Photos To Add To Your Website',
    'dek':
      <>
        <p>Fun fact: Guests love seeing photos of you two throughout the years. Give ‘em what they want, and personalize your website with:</p>
        <ul>
          <li>Engagement photos</li>
          <li>Photos from recent trips you took together</li>
          <li>Baby photos</li>
          <li>Photos with your friends and family</li>
          <li>Photos with your pets</li>
          <li>Any other special shots you’d like to share</li>
        </ul>
        { expertAdviceBlock }
      </>,
  },
  'POI': {
    'title': '3 Tips For Finding Things To Do',
    'dek':
      <>
        <p>Give guests the best experience throughout the entire wedding weekend with a list of things to do and eat around town. As you gather your recommendations, here are three tips to keep in mind.</p>
        <ol>
          <li>
            <p><strong>Make sure there’s something for everyone.</strong></p>
            <p>From dive bars and art museums to food trucks and fine dining spots, try to provide a variety of options for guests. Don’t forget to include kid-friendly suggestions, too, for guests who are bringing their children.</p>
          </li>
          <li>
            <p><strong>Go with your favorites.</strong></p>
            <p>If you’re getting married in a city you know well, you can’t go wrong with listing all your go-to spots. You can even recommend places that are significant to you two, from the karaoke bar where you met to the beautiful park where you got engaged.</p>
          </li>
          <li>
            <p><strong>Ask your venue for suggestions.</strong></p>
            <p>One easy way to find things to do for guests? Ask your venue, or other vendors who are local to your wedding destination, for their picks. They’ll know all the can’t-miss restaurants and sites to see.</p>
          </li>
        </ol>
        { expertAdviceBlock }
      </>,
  },
}

export default EditPagesTipsContent;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EditPagesTipsContent.jsx